import { BACKEND_PRIVATE } from '@/api/base'

export async function sendApplication(payload: LX.JobApplicationPayload) {
  return BACKEND_PRIVATE.post('/me/jobs/simple/applications/create-combined-as-freelancer', { payload })
}

export async function declineApplicationAsFreelancer(id: number) {
  return BACKEND_PRIVATE.post(`/me/jobs/simple/applications/decline-as-freelancer?id=${id}`)
}

export async function declineApplicationAsCustomer(id: number) {
  return BACKEND_PRIVATE.post(`/me/jobs/simple/applications/decline-as-customer?id=${id}`)
}

export async function getApplication(id: number) {
  return BACKEND_PRIVATE.get<LX.JobApplication>('/me/jobs/simple/applications/get', { params: { id } })
}

export async function readApplications(ids: number[]) {
  return BACKEND_PRIVATE.post(`/me/jobs/simple/applications/mark-read`, null, { params: { ids } })
}

export async function setApplicationMeta(id: number, meta: Record<string, boolean>) {
  return BACKEND_PRIVATE.post('/me/jobs/simple/applications/upsert-tabs-meta', { id, meta })
}
